import "./middleCarrouselTeam.sass";

export default function MiddleCarrouselTeam({ updateView, showCalendar }) {
  const buttons = [
    { label: "Calendario", value: true },
    { label: "Resultados", value: false }
  ];

  return (
    <div className="carrousel-team__middle">
      {buttons.map(({ label, value }) => (
        <button
          key={label}
          className={showCalendar === value ? "active" : ""}
          onClick={() => updateView(value)}
          type="button"
        >
          {label}
        </button>
      ))}
    </div>
  )
}